import { LearnLayout } from "./Layout/LearnLayout";

export const VisionLearn = () => {
  return (
    <LearnLayout videoUrl="https://www.loom.com/embed/1f7c4b298461477c93495430260d8f7b?sid=a624fcad-747d-47b4-8598-70eee4a41a10">
      <h3>Vision</h3>
      <p>
        Ambitious founders believe their company can make the world a better
        place. They're deeply frustrated with the way things are and are driven
        by the desire to create a positive, meaningful change. A vision
        statement captures this reimagined world. It's future-based,
        aspirational, and helps you conceptualize a world free from the problems
        you're trying to address.
      </p>
      <h4>What Is It</h4>
      <p>
        A description of the future that begins with "We envision a world
        where..." whilst describing what the world looks like without the
        problems you are fixing.
      </p>
      <h4>How It Works</h4>
      <p>
        1. Identify the problem: What exactly frustrates you about the current
        state of the world?
      </p>
      <p>
        2. Reimagine reality: How would the world change if this specific
        situation were to be better?
      </p>
      <p>
        3. Make it aspirational: Rather than viewing this statement as a finish
        line, try to position your vision statement as an ongoing pursuit.
      </p>
      <h4>The Result</h4>
      <p>
        A unified vision of the future that motivates you and your team to grasp
        why your company must exist.
      </p>
      <h4>How Vojomo Helps</h4>
      <p>
        Talk to Vo about your vision by starting with the phrase "We envision a
        world in which/where…". Be as descriptive as you possibly can. You can
        also check out the video for a deeper dive into the philosophy behind
        building an effective vision and how the Vojomo app can help you create
        it.
      </p>
    </LearnLayout>
  );
};
